import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from '../overlay/Dialog';
import OverlayController from '../overlay/OverlayController';
import mutations from '../../graphql/mutations';
import { compose } from 'react-apollo';
import './CreateProjectDialog.css';

class CreateProjectDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            projectName: ''
        };
    }

    didChangeProjectName(projectName) {
        this.setState({projectName});
    }

    didClickSave(event) {
        event.preventDefault();
        OverlayController.showActivityIndicator();
        this.props.createProject(this.state.projectName.trim())
            .then(({data}) => {
                OverlayController.hideActivityIndicator();
                OverlayController.hideOverlay();
            })
            .catch((error) => {
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    render() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Save', type: "submit", handler: this.didClickSave.bind(this), disabled: this.state.projectName.trim().length === 0}
        ];
        return (
            <Dialog showTitleBar={true} title={`Create Project`} actions={actions}>
                <form>
                    <TextField
                        className="custom-field"
                        fullWidth={true}
                        floatingLabelText="Project Name"
                        floatingLabelFixed={true}
                        hintText="Enter title for the project"
                        value={this.state.projectName}
                        onChange={(event) => this.didChangeProjectName(event.target.value)}/>
                </form>
            </Dialog>
        );
    }
}

export default compose(
    mutations.createProjectMutationHoc
)(CreateProjectDialog);



// WEBPACK FOOTER //
// ./src/components/sidebar/CreateProjectDialog.js